import React from 'react'

import { Button, ButtonProps } from 'semantic-ui-react'
import { Tooltip } from './Tooltip'

export interface TooltipButtonProps extends ButtonProps {
  title: React.ReactNode
}

export const TooltipButton: React.FC<TooltipButtonProps> = (props: TooltipButtonProps) => {
  const { title, ...rest } = props
  return <Tooltip disabled={props.disabled ?? !title} content={title} trigger={<Button {...rest} />} />
}

TooltipButton.displayName = 'TooltipButton'
